import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {MatTableDataSource as MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-most-search-key-worlds',
  templateUrl: './most-search-key-worlds.component.html',
  styleUrls: ['./most-search-key-worlds.component.css']
})
export class MostSearchKeyWorldsComponent implements OnInit {
  displayColumns: string[] = ["keyword", "count"]
  dataSource = new MatTableDataSource<any>([])
  isLoading: boolean = false
  index: number = 0;
  size: number = 10;
  dataLength: number = 0;
  data: any = {};
  constructor(private httpClient: HttpClient) { }

  ngOnInit() {

    this.getMostSearchKeywords();
  }


  getMostSearchKeywords() {
    this.data = {
      pagination: { start: this.index, number: this.size },
      search: {
        predicateObject: {}
      },
      sort: {}
    }
    this.httpClient.post(`/search/MostSearchKeywords`, this.data).subscribe((res: any) => {
      this.dataSource = res.data;
      this.dataLength = res.totalCount;
      this.isLoading = true;
    })
    err => {
      this.isLoading = true;
      console.log(err.message)
    }
  }
  changePage(event) {
    this.index = event.pageIndex;
    this.size = event.pageSize;
    this.getMostSearchKeywords()
  }


}
